// TODO: Add types
export const dynamicTemplate = (
    templateString = '',
    templateVariables: any = null,
) => {
    if (!templateVariables) {
        return templateString;
    }

    return templateString.replace(/\${(.*?)}/g, (_, g) => templateVariables[g]);
};
